import { EventEmitter, Injectable, Output } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormInfoByCisloJrDto } from '../dto/FormInfoByCisloJrDto';
import { FillFormService } from '../services/fill-form.service';

@Injectable({
  providedIn: 'root'
})
export class CjrMaLicenciAsyncValidator implements AsyncValidator {

  constructor(
    private fillFormService: FillFormService
  ) { }

  @Output() licenceEvent: EventEmitter<FormInfoByCisloJrDto> = new EventEmitter<FormInfoByCisloJrDto>();

  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    if (control.value == void 0 || control.value == '') {
      this.licenceEvent.emit(null);
      return null;
    }
    else {
      return this.fillFormService.getLicenceDodavatelInfo(control.value)
        .pipe(
          map(resp => {
            let errors = {};
            if (resp != void 0) {
              if (!resp.success) {
                if (resp.data != void 0 && resp.data.licence == void 0) {
                  errors['licenceError'] = 'Dodavatel nemá platnou licenci.';
                }
                else {
                  errors['licenceError'] = 'Dodavatel nebyl nalezen.';
                }
              }
            }
            else {
              errors['licenceError'] = 'Chyba získání licence.';
            }

            this.licenceEvent.emit(resp?.data);
            return Object.keys(errors).length > 0 ? errors : null;
          })
        );
    }
  }
}
